import {UnLitElement} from "../../common/elements";
import {customElement, property} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {unsafeHTML} from "lit/directives/unsafe-html.js";
import {Role} from "./gptChatApp";

@customElement("eop-career-gpt-message")
export class CareerGptMessage extends UnLitElement {
    @property({attribute: "message", type: String})
    public message: string;
    @property({attribute: "role", reflect: true, type: Role})
    public role: Role;

    public connectedCallback(): void {
        super.connectedCallback();
    }

    public render(): TemplateResult {
        return html`
            <div class="chat-message">
                <div class="chat-message-content">${unsafeHTML(this.message)}</div>
            </div>
        `;
    }
}